/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * This module makes sure that if a person is on a page that they
 * have lost permission to see, that they are routed to the 'contact profile'
 * page.
 */

var Model = require("../types/DebouncedModel.js");

var PERMISSIONS = {
	"manage": ["managed_managers", "managed_managers_permissions", "managed_manager_requests"],
	"personal": ["managed_preferences"],
	"urgencycontacts": [],
	"contacts": [],
	"device": [],
	"atouchaway": [],
	"reminders": [],
	"files": [],
	"forms": [],
	"metrics": [],
	"careplan_Appointments": [],
	"careplan_CareTeam": [],
	"careplan_Client": [],
	"careplan_Goals": [],
	"careplan_HealthAssessments": [],
	"careplan_HealthConditions": [],
	"careplan_HospitalVisits": [],
	"careplan_OtherTreatments": [],
	"careplan_Situation": [],
	"careplan_Supports": [],
	"careplan_Treatments": []
};

module.exports = Model({
	name: "permissionenforce",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_current_page: null,

	handle_current_page: handle_current_page,
	handle_update: handle_update,
	sendPage: sendPage
});

function init() {
	this._current_page = null;
}

function uninit() {
	this._current_page = null;
}

function listeners() {
	return {
		"desktop:updated": handle_current_page,
		"managementpermissions:updated": handle_update
	};
}

function handle_current_page(data) {
	var current_page = data.page;
	this._current_page = current_page;
}

function handle_update(permissions) {
	// Generate an array of currently 'forbidden' permissions
	var forbidden = Object.keys(permissions).reduce(function(acc, permission) {
		if (!permissions[permission]) acc = acc.concat(permission);
		return acc;
	}, []);

	var current = this._current_page;

	// See if the current page is associated with a permission in a 'forbidden'
	// state.  If so, set the page immediately to the contact profile page.
	forbidden.map(function(permission) {
		if (PERMISSIONS[permission] && PERMISSIONS[permission].indexOf(current) !== -1) {
			this.sendPage({
				page: "contactprofile"
			});
		}
	}, this);
}

function sendPage(page) {
	this.emit("desktop:trigger:page:replace", page);
}
